import 'flowbite';

var swiper = new Swiper('.swiper-banner', {
    loop: true,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
});

var swiper_conceitos = new Swiper(".swiper-conceitos", {
    slidesPerView: 1,
    spaceBetween: 10,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    breakpoints: {
      640: {
        slidesPerView: 1,
        spaceBetween: 30,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
    },
});

var swiper_galeria = new Swiper('.swiper-galeria', {
    loop: true,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: ".galeria-single-button-next",
      prevEl: ".galeria-single-button-prev",
    },
});

var swiper_produtos = new Swiper('.swiper-produtos', {
    loop: true,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: ".destaques-button-next",
      prevEl: ".destaques-button-prev",
    },
});

var swiper_cases = new Swiper(".swiper-cases", {
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
  slidesPerView: 1,
  spaceBetween: 10,
  breakpoints: {
    640: {
      slidesPerView: 2,
      spaceBetween: 30,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 30,
    },
  },
  navigation: {
    nextEl: ".cases-button-next",
    prevEl: ".cases-button-prev",
  },
});


var swiper_galeria_cases = new Swiper(".swiper-galeria-cases", {
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
  slidesPerView: 1,
  spaceBetween: 10,
  breakpoints: {
    640: {
      slidesPerView: 1,
      spaceBetween: 30,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 30,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
  },
  navigation: {
    nextEl: ".galeria-single-button-next",
    prevEl: ".galeria-single-button-prev",
  },
});